<template>
  <zm-form-item
    v-if="visiblePbxBasePlans.length"
    :label="$t('billing.zone_pro_plus.pbx_base_title')"
    class="opc-pbx-base-row vertical-form-item">
    <zm-tooltip
      slot="label-suffix"
      v-model="callingFeeTipsVisible"
      aria-label="Learn more about 'How will international fees be handled?'"
      placement="top"
      popper-class="pbx-title-tips"
      tab-to-leave
    >
      <p slot="content" v-html="$t('billing.pbx.calling_fee_tips', [$t('billing.pbx.regions.US')])"></p>
      <zm-button
        ghost
        icon="zm-icon-info-outline main-color-icon"
        size="mini"
        type="icon"
        @click="showCallingFeeTips" />
    </zm-tooltip>
    <zm-radio-group
      :aria-label="$t('billing.zone_pro_plus.pbx_base_title')"
      :value="planCode"
      name="pbx-base"
      class="opc-card-radio opc-calling-fees-radios"
      @change="handleBasePlanChange"
      @input="changePlanCode">
      <zm-radio
        v-for="plan in visiblePbxBasePlans"
        :key="plan.plan_code"
        :label="plan.plan_code"
      >
        <p class="opc-pbx__fees-title">{{ $t(getCallingFeesText(plan).title) }}</p>
        <p class="opc-pbx__fees-cost">
          <span class="opc-pbx__fees-cost-price">
            {{ $money(plan.amount, { forceDiff: true }) }}
          </span>
          <span>{{ $t(getCallingFeesText(plan).unit) }}<priceVATTip /></span>
        </p>
      </zm-radio>
    </zm-radio-group>
  </zm-form-item>
</template>

<script type="text/jsx">
import { getCurrentTrackingPlanName, getZPCallingFeesText } from '@/plans/ZOOM_PHONE/helper/utils';
import { BILLING_CYCLE } from '@/common/constants';
import PbxMixin from '../mixin/pbx-mixin';
import { mapActions } from 'vuex';

export default {
  name: 'config-pbx-base',
  mixins: [PbxMixin],
  model: {
    prop: 'planCode',
    event: 'changePlanCode',
  },
  props: {
    planCode: String,
    billingCycle: String,
  },
  data() {
    return {
      /** tooltips state **/
      callingFeeTipsVisible: false,
    };
  },
  computed: {
    visiblePbxBasePlans() {
      return this.pbxBasePlansGroupByBillingCycle[this.billingCycle] || [];
    },
    trackingPlanName() {
      return getCurrentTrackingPlanName();
    },
  },
  methods: {
    ...mapActions(['switchSelectPlanAction']),
    getCallingFeesText: getZPCallingFeesText,
    handleBasePlanChange(value) {
      this.switchSelectPlanAction([
        this.selectedPbxBasePlan.plan_code,
        {
          plan_code: value,
          cartInfo: { selected_number: 1 },
        },
      ]);

      this.$nextTick(() => {
        const cycle = this.selectedPbxBasePlan?.billing_cycle === 'monthly' ? 'month' : 'year';
        const baseName = this.selectedPbxBasePlan.billing_cycle !== BILLING_CYCLE.PAY_AS_YOU_GO ?
          `Metered Calling Credits prepaid ${this.$money(this.selectedPbxBasePlan.amount)}/${cycle}` :
          `Metered Calling Credits Pay as You Go'`;
        this.$tracking.buyInteraction(`${this.trackingPlanName} international calling fees`, baseName);
      });
    },
    /** tooltips state exchange **/
    showCallingFeeTips() {
      if (this.$context.is.mobile) {
        this.callingFeeTipsVisible = !this.callingFeeTipsVisible;
      }
    },
    changePlanCode(val) {
      this.$emit('changePlanCode', val);
    },
  },
  watch: {
    callingFeeTipsVisible(v) {
      v && this.$tracking.buyInteraction(`${this.trackingPlanName} options`, 'How will international fees be handled? - tooltip');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.opc-pbx-base-row {
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  .zm-form-item {
    &__label {
      font-size: 18px;
      font-weight: 700;
      line-height: 27px;
      letter-spacing: 0em;
      text-align: left;
      padding-right: 0px;
    }
  }

  .opc-calling-fees-radios {
    margin-top: 8px;
  }

  &.vertical-form-item {
    .zm-form-item__content .opc-card-radio .zm-radio {
      flex: 1;
    }

    .zm-form-item__content .opc-card-radio .zm-radio__label .zm-radio__label--inner,
    .zm-form-item__content .opc-card-radio .zm-radio .zm-radio__wrap {
      width: 100%;
    }
  }
}
</style>
